const TrimConditions = [
    { text: 'Excellent', value: 'excellent' },
    { text: 'Very Good', value: 'veryGood' },
    { text: 'Good', value: 'good' },
    { text: 'Fair', value: 'fair' },
];
export default TrimConditions;
